import { FormArray, FormGroup } from '@angular/forms';
import { SolutionPath, StemMarkScheme } from '@examdojo/models/markscheme-v2';
import { QuestionEditingOptions } from '@examdojo/models/question-editor';
import { createMarkGroupFormGroup, MarkGroupFormGroup } from './markscheme-markgroup';
import { createSolutionPathFormGroup, SolutionPathFormGroup } from './solution-path';
import { validateMarkschemeRefsValidator } from './markscheme-solution-path-validator';

export type MarkschemeFormGroup = FormGroup<{
  all_mark_groups: FormArray<MarkGroupFormGroup>;
  solution_paths: FormArray<SolutionPathFormGroup>;
}>;

export type MarkschemeFormGroupType = MarkschemeFormGroup;

export function createSolutionPathsFormArray(
  solutionPaths: SolutionPath[],
  options: QuestionEditingOptions,
): FormArray<SolutionPathFormGroup> {
  return new FormArray<SolutionPathFormGroup>(
    solutionPaths.map((solutionPath) => createSolutionPathFormGroup(solutionPath, options)),
  );
}

export function createMarkschemeFormGroup(
  markscheme: StemMarkScheme,
  options: QuestionEditingOptions,
): MarkschemeFormGroup {
  // Markgroup subparts should be editable only when the markscheme is editable,
  // no matter what the question editing options are
  options = { ...options, allowQuestionEditing: true };

  const form = new FormGroup({
    all_mark_groups: new FormArray<MarkGroupFormGroup>(
      markscheme.all_mark_groups.map((markGroup) => createMarkGroupFormGroup(markGroup, options)),
    ),
    solution_paths: createSolutionPathsFormArray(markscheme.solution_paths, options),
  });

  if (options.allowMarkschemeStructureEditing) {
    form.addValidators(validateMarkschemeRefsValidator());
    form.updateValueAndValidity();
  }

  return form;
}
